import React from 'react'

function SuperAdminLayout() {
  return (
    <div>SuperAdminLayout</div>
  )
}

export default SuperAdminLayout